import { render, staticRenderFns } from "./userUploadNum.vue?vue&type=template&id=5ca83220&scoped=true&"
import script from "./userUploadNum.vue?vue&type=script&lang=js&"
export * from "./userUploadNum.vue?vue&type=script&lang=js&"
import style0 from "./userUploadNum.vue?vue&type=style&index=0&id=5ca83220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca83220",
  null
  
)

export default component.exports